import { profilesApi } from '@/api';
import { ErrorNotificationIcon, SuccessNotificationIcon } from '@/assets/icons';
import { useToast } from '@/store/useToast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export const useClearChatWhithUser = (chatId: number | '') => {
    const queryClient = useQueryClient();

    const showToast = useToast((state) => state.show);

    const { t } = useTranslation();

    const mutation = useMutation({
        mutationFn: profilesApi.deleteChatWithUser,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['profiles', `chat-${chatId}`] });
            showToast({
                // type success
                icon: <SuccessNotificationIcon />,
                msg: t('msgs.chat_success_clean')
            });
        },
        onError: (error) => {
            console.error('Error unvote profile:', error);
            showToast({
                // type error
                icon: <ErrorNotificationIcon />,
                msg: t('error_try_again')
            });
        },
    });

    return mutation;
};
